<template>
  <div>
    <el-drawer @reload="$reloadHandle"
               title="工单预约" size="48%"
               :before-close="handleClose"
               :visible.sync="drawer"
               direction="rtl"
               :modal-append-to-body="true"
               custom-class="demo-drawer"
               ref="drawer"
    >

      <div class="demo-drawer__content">
        <el-form :model="formData">

          <el-form-item   label="预约结果" label-width="150px" :readonly="true">
            <el-select v-model="formData.bookType">
              <el-option label="预约成功" :value="1"/>
              <el-option label="预约失败" :value="2"/>
            </el-select>
          </el-form-item>

          <el-form-item label="改约次数" label-width="150px" :readonly="true">

            <span class="title1">{{ formData.bookTimes }}</span>


            </el-form-item>
            <el-form-item label="最大预约次数" label-width="150px">
              <!-- <span class="title1">:</span> -->
              <span v-if="formData.companyMaxBookTimes==0" class="title1">无限制</span>
              <span v-else class="title1">{{ formData.companyMaxBookTimes }}</span>
            </el-form-item>
            <el-form-item   label="改约原因" label-width="150px" :readonly="true">

              <el-select v-model="formData.changeBookReasn" :disabled="BookReasn" placeholder="" @change="updateReasonOption" style="width: 7vw!important;">
                <el-option v-for="item in bookReasnList" :key="item.value" :label="item.label"
                           :value="item.value"/>
              </el-select>
            </el-form-item>
          <el-form-item label="上次预约时间" label-width="150px">

            <el-date-picker v-model="formData.bookDate" disabled="true" type="date" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期" @change="validateTime" style="width: 7vw!important;" >
            </el-date-picker>
            <!-- <el-select disabled="true" v-model="formData.bookDatePeriod" style="width: 7vw;" @change="validateTime" clearable>
              <el-option label="08:00-10:00" value="08:00-10:00"/>
              <el-option label="10:00-12:00" value="10:00-12:00"/>
              <el-option label="12:00-14:00" value="12:00-14:00"/>
              <el-option label="16:00 以后" value="16:00 以后"/>
            </el-select> -->
            <el-input v-model="formData.bookDatePeriod"  disabled="true" style="width:7vw ;" />

          </el-form-item>

          <el-form-item label="本次预约时间" label-width="150px">
            <!-- <span class="title1"></span> -->
            <el-date-picker v-model="formData.reBookDate" type="date" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期" @change="validateTime" style="width: 7vw!important;" >
            </el-date-picker>
            <!-- <el-select  v-model="formData.reBookDatePeriod" style="width: 7vw;" @change="validateTime" clearable>
              <el-option label="08:00-10:00" value="08:00-10:00"/>
              <el-option label="10:00-12:00" value="10:00-12:00"/>
              <el-option label="12:00-14:00" value="12:00-14:00"/>
              <el-option label="16:00 以后" value="16:00 以后"/>
            </el-select> -->
                <el-time-picker style="width: 7vw;"

        v-model="formData.reBookDatePeriod"

        placeholder="任意时间点" value-format="HH:mm:ss">
              </el-time-picker>
          </el-form-item>

          <el-form-item label="预约备注" label-width="150px">

            <el-input v-model="formData.bookRemark" size="small" type="textarea" :rows="7" style="width:14vw ;" />
          </el-form-item>

        </el-form>
        <div class="title first"   v-if="formData.reportList && formData.reportList.length > 0"><b>预约当天工单占用分布</b></div>
        <vxe-table style="margin-top: 0px;" :stripe="true"
                   :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea',
                    fontSize: '12px', color: '#808080', width: '95%' }"
                   :row-style="{ fontSize: '12px', }"
                   show-overflow height="210" :column-config="{ resizable: true }"
                   v-if="formData.reportList && formData.reportList.length > 0"
                  :data="formData.reportList">

          <vxe-column field="engineer_name" title="师傅名称" align="center" width="120"/>
          <vxe-column field="zeroToEight" title="00-08"  align="center" width="70"/>
          <vxe-column field="eightToTen" title="08-10"  align="center" width="70"/>
          <vxe-column field="tenToTwelve" title="10-12" align="center" width="70"/>
          <vxe-column field="twelveToFourteen" title="12-14" align="center" width="70"/>
          <vxe-column field="fourteenToSixteen" title="14-16" align="center"  width="70"/>
          <vxe-column field="sixTeenToEighteen" title="16-18" align="center" width="70"/>
          <vxe-column field="eighteenToTwenty" title="18-20" align="center" width="70"/>
          <vxe-column field="twentyToTwentyFour" title="20-24" align="center" width="70"/>
        </vxe-table>

        <div class="demo-drawer__footer" style="position: absolute; bottom: 5px; right: 5px;">
          <el-button @click="cancelForm">取 消</el-button>
          <el-button type="primary" @click="rebook">
            确 定
          </el-button>
        </div>
      </div>

    </el-drawer>

  </div>
</template>
<script>
import store from "@/store";
import api from "@/api/projectApi";
import duDialog from "@/views/dialogCommon/adminDialogByRole.vue";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import orderPop from "@/views/dialogCommon/radioOrderDialog.vue";
import {dictType, loadDictData} from "@/config/dictType";
import request from "@/router/axios";
import pager from "@/components/pager/index.vue";
import {indexPageMixins} from "@/mixins/tabChang";

export default {
  inject: ['reload'],
  name: 'edit',
  props: ['multi', 'param'],
  mixins: [indexPageMixins],

  created() {
    this.dataId = this.param ? this.param.orderId ? this.param.orderId : '' : ''
    this.showInRemark = this.param ? this.param.showInRemark ? this.param.showInRemark : '' : ''
    this.orderRemarkData.id = this.param ? this.param.orderId ? this.param.orderId : '' : ''
  },
  mounted() {
    this.getData()
    this.loadDictData();
  },
  components: {pager},
  computed: {
    api() {
      return api
    },
    idsLength() {
      this.formData.numuber =  this.ids.length;
      this.formData.ids = this.ids;
    },

    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      }
    },
  },
  watch: {

  },
  data() {
    return {
      type:null,
      showSitePop:false,
      bookReasnList:[],
      engineerReport:[],
      BookReasn:false,
      disableForReson:false,
      dataId:null,
      timeSlots:[],
      capacityData:[
        {str:"08-10"},
        {str:"10-12"},
        {str:"12-14"},
        {str:"14-16"},
        {str:"16-18"},
        {str:"18-20"},
        {str:"20-24"},
      ],
      formData: {
        reportList:[],
        engineerId:null,
        siteId:null,
        changeBookReasn:null,
        changeBookReasnValue:null,
        bookTimes:0,
        remark: null,
        firstBookDate:"",
        bookDate:"",
        bookDatePeriod:"",
        reBookDate:"",
        reBookDatePeriod:"",
        companyMaxBookTimes:0,
        bookRemark: '',
        bookType:1
      },
      showOrderPop: false,

      drawer: true,


    }
  },
  methods: {
    loadDictData() {
      //改约原因
      loadDictData(dictType.bookReason).then(res => {
        this.sysDictItemList = []
        res.data.data.forEach(item => {
          this.bookReasnList.push({
            label: item.label,
            value: item.id
          })
        })
      })
    },

    rebook(id){
      if(this.formData.bookType==1) {
        if (this.formData.reBookDate == '' || this.formData.reBookDate == null) {
          this.$message.error('请选择本次预约时间');
          return;
        }
        if (this.formData.firstBookDate != null && (this.formData.changeBookReasn == null || this.formData.changeBookReasn == '')) {
          this.$message.warning('二次预约改约原因必填');
          return;
        }
        if (this.formData.companyMaxBookTimes != 0 && this.formData.bookTimes + 1 > this.formData.companyMaxBookTimes) {
          this.$message.warning('已超过最大预约次数,不允许再改约;');
          return;
        }
        if (this.formData.companyMaxBookTimes != 0 && this.formData.bookTimes + 1 == this.formData.companyMaxBookTimes) {
          if (this.formData.reBookDatePeriod == '' || this.formData.reBookDatePeriod == null) {
            this.$message.warning('最后一次预约，必须填写时间点');
            return;
          }
        }
        if (this.formData.reBookDatePeriod != '' && this.formData.reBookDatePeriod != null) {
          const reBookDate = new Date(this.formData.reBookDate);
          const year = reBookDate.getFullYear();
          const month = reBookDate.getMonth() + 1;
          const day = reBookDate.getDate();
          const reBookDateStr = `${year}-${month}-${day}`;

          const selectDate = reBookDateStr + ' ' + this.formData.reBookDatePeriod
          const nowTimeStamp = Date.now();
          const reBookDatePeriodTimeStamp = Date.parse(selectDate)
          if (reBookDatePeriodTimeStamp < nowTimeStamp) {
            this.$message.warning('预约时间不能早于当前操作时间');
            return;
          }
        }
      }
      this.$mask.open()

      this.$http({
        url: api.soOrder.reBookUrl,
        method: 'post',
        data: {
          id:this.dataId,
          changeBookReasn:this.formData.changeBookReasn,
          changeBookReasnValue:this.formData.changeBookReasnValue,
          bookDate:this.formData.reBookDate,
          bookDatePeriod:this.formData.reBookDatePeriod,
          bookRemark:this.formData.bookRemark,
          bookType:this.formData.bookType
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.$message({
          type: response.data.type,
          message: response.data.content
        });
        this.drawer = false;
        this.$emit('closeBook', 1)
      }).catch(() => {
        this.$mask.close()
      });
    },

    getData() {
      request({
        url: api.soOrder.getDataUrl,
        method: 'post',
        data: {
          id: this.dataId
        },
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        this.formData.firstBookDate = response.data.data.soOrderProcessDTO.firstBookDate;
        this.formData.bookTimes = response.data.data.soOrderProcessDTO.bookTimes;
        this.formData.bookDate = response.data.data.soOrderProcessDTO.bookDate;
        this.formData.bookDatePeriod = response.data.data.soOrderProcessDTO.bookDatePeriod;
        this.formData.changeAppointmentDate = response.data.data.soOrderProcessDTO.changeAppointmentDate;
        this.formData.siteId = response.data.data.siteId
        this.formData.engineerId = response.data.data.engineerId
        this.formData.companyMaxBookTimes = response.data.data.companyMaxBookTimes;
        if(this.formData.bookTimes==0||this.formData.bookTimes==null){
          this.formData.bookTimes=0;
          //this.BookReasn = true;
        }
        if(this.formData.firstBookDate==null){
          this.BookReasn = true;
        }
        if(this.formData.bookDate==null){
          if(this.formData.changeAppointmentDate==null){
            this.formData.bookDate = this.formData.firstBookDate
          }else {
            this.formData.bookDate = this.formData.changeAppointmentDate
          }

        }
        if(this.formData.companyMaxBookTimes==null || this.formData.companyMaxBookTimes==0){
          this.formData.companyMaxBookTimes=0;
        }
      })
    },

    updateReasonOption() {
      const selectedOption = this.bookReasnList.find(item => item.value === this.formData.changeBookReasn);
      if (selectedOption) {
        this.formData.changeBookReasnValue = selectedOption.label;
      } else {
        this.formData.changeBookReasnValue = null;
      }
    },



    validateTime() {
      const selectedDate = new Date(this.formData.reBookDate); // 将选择的日期转换为Date对象
      const currentTime = new Date(); // 当前时间
      selectedDate.setHours(0, 0, 0, 0); // 将选择的时间设置为当天的0点0分0秒
      currentTime.setHours(0, 0, 0, 0);
      if (selectedDate < currentTime) {
        // 如果选择的日期与当前日期相同，并且选择的时间小于当前时间，则重置选择框的值
        this.formData.reBookDate = '';
        this.$message.error('选择的日期不能小于当前日期');
      }else{
        request({
          url: api.snSiteEngineerDispatch.dispatchReportUrl,
          method: 'post',
          data: {
            siteId: this.formData.siteId,
            bookDate: this.formData.reBookDate,
            engineerId:this.formData.engineerId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          console.log("获取预约看板数据：",response)
          this.formData.reportList = response.data.data
        })
      }

    },

    cancelForm() {
      this.loading = false;
      this.drawer = false;
      clearTimeout(this.timer);
      this.$emit('closeBook', false)
    },

    handleClose() {
      this.drawer = false;
      this.$emit('closeBook', false)
    },
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer .el-drawer__body {
  padding: 0 16px;
  background-color: #fff;
  position: relative;
}

::v-deep .el-drawer .el-drawer__header {
  background-color: #fff;
}

::v-deep .el-drawer__container {
  position: relative;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background: aliceblue;
  background-color: rgb(38 38 38 / 70%);
}

#containt .table-detail {
  border-collapse: collapse;
  font-size: 12px;
  border: 1px solid #ededed;
}

.btn {
  text-align: center;
}
::v-deep .el-select>.el-input {
  width: 7vw;
}

::v-deep .el-input-number [role=button] {
  line-height: 26px;
  height: 26px;
  margin-top: 40px;
}
.el-input-number--medium {
  width: 200px;
  display: block;
  line-height: 34px;
}
.title1{
  display: inline-block;
  width: 100px;
  color: #72767b;
  font-size: 13px;
  text-align: end;
  margin: 5px 10px;
}
</style>
